import type { Frame } from '../store/types';

const DESIGN_KINDS = new Set<Frame['kind']>([
  'free', 'main', 'instance', 'tsxFree', 'tsxMain', 'tsxInstance',
]);

export function isDesignFrameKind(k: Frame['kind']): boolean {
  return DESIGN_KINDS.has(k);
}

export type ChatTarget =
  | { scope: 'frame'; anchorId: string }
  | { scope: 'global' };

/** Decide which conversation a chat action targets, given current selection. */
export function decideChatTarget(selection: string[], frames: Frame[]): ChatTarget {
  if (selection.length === 1) {
    const f = frames.find((x) => x.id === selection[0]);
    if (f && isDesignFrameKind(f.kind)) return { scope: 'frame', anchorId: f.id };
  }
  return { scope: 'global' };
}

/** One rule: chat scope follows the current selection. A frame-scoped thread
 *  when a single design frame is selected, the whole-canvas thread otherwise.
 *  `globalOverride` is the ephemeral un-scope affordance (never persisted;
 *  cleared when the selection changes). */
export function panelChatScope(
  globalOverride: boolean,
  canScopeToFrame: boolean,
): 'frame' | 'global' {
  return !globalOverride && canScopeToFrame ? 'frame' : 'global';
}
